export const generateForm = (method = 'get', action, target) => {
	const form = document.createElement('form');
	if (method) form.method = method;
	if (target) form.target = target;
	if (action) form.action = action;

	return form;
};

export const setFormParam = (form, name, value) => {
	const hiddenField = document.createElement('input');
	hiddenField.type = 'hidden';
	hiddenField.name = name;
	hiddenField.value = value;

	form.appendChild(hiddenField);
};

export const submitForm = (form) => {
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

export const getStatusFromAgreements = (agreements) => agreements?.filter((v) => v.agreed).map((v) => v.agreementType) || [];
